import { NpHtmlSection } from "src/components/np-design/sections/markdown/NpHtmlSection"
import { useProductContext } from "./context"

export const ProductSeoText = () => {
  const { seoText } = useProductContext()

  if (!seoText?.trim().length) {
    return null
  }

  return <NpHtmlSection html={seoText} align="left" />
}
